<template>
  <vc-tutorial>
    <div class="vc-tutorial__content">
      <vc-tutorial-carousel class="vc-carousel">
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              Por que <span>conferir os valores</span> das vendas e
              <span>fechar o caixa</span>?
            </h2>
          </div>
          <div class="vc-tutorial__content-info">
            <div class="vc-info-box">
              <h2>Comparar os dados com valores reais</h2>
              <p>
                O fechamento de caixa é um processo de conferência de
                <b>todas as transações realizadas</b> em suas empresas
              </p>
              <img alt="Imagem comparar valores reais" :src="compararDados" />
              <p>Por exemplo: <b>dinheiro, Pix, crédito parcelado, etc.</b></p>
            </div>

            <div class="vc-info-box">
              <h2>Saldo em conta sempre atualizado</h2>
              <p>
                Também é possível acompanhar as
                <b>receitas, despesas e depósitos</b> realizados em cada dia
                conferido
              </p>
              <img alt="Imagem saldo em conta atualizado" :src="saldoEmConta" />
              <p>Saiba quanto <b>dinheiro</b> tem <b>disponível</b> na conta</p>
            </div>
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              Confira os <span>valores reais</span> das vendas e feche os
              períodos para evitar erros
            </h2>
            <small>
              <b>Após filtrar</b> uma empresa e um mês,
              <b>selecione um dia</b> com vendas e clique em
              <b>Salvar vendas</b> ou <b>Fechar período</b>
            </small>
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Imagem valores reais" :src="valoresReais" />
          </div>
        </li>
        <li>
          <div class="vc-tutorial__content-header">
            <h2>
              <span>Digite os valores reais</span> e outras informações do dia
            </h2>
            <small>
              Caso existam diferenças é preciso informar uma <b>Modalidade</b> e
              uma <b>Justificativa</b>
            </small>
          </div>
          <div class="vc-tutorial__content-info">
            <img alt="Imagem Digite os valores reais" :src="digiteValores" />
          </div>
        </li>
      </vc-tutorial-carousel>
    </div>
  </vc-tutorial>
</template>

<script setup lang="ts">
import compararDados from "./Images/FechamentoDeCaixa/compararDados.svg";
import saldoEmConta from "./Images/FechamentoDeCaixa/saldoEmConta.svg";
import valoresReais from "./Images/FechamentoDeCaixa/valoresReais.gif";
import digiteValores from "./Images/FechamentoDeCaixa/digiteValores.gif";
</script>
<style lang="scss">
@import url("./style.scss");
</style>
